import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';

import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';

import OrderAttributes from './OrderAttributes';


const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'require';
  }
};

const isEmptyObject = (obj) => {
  for ( var prop in obj ) {
    return false;
  }
  return true;
};

class AssignOrderPage extends Component {
  constructor(props) {
    super(props);

    if (props.location.state === undefined || props.location.state.fboId === undefined) {
      this.goBack();
    }

    const parsedOrderId = parseInt(this.props.match.params.orderId, 10);
    const parseFboId = parseInt(props.location.state.fboId, 10);

    this.state = {
      fboId: parseFboId,
      id: parsedOrderId,
      assigning: true,
      fuelOrder: undefined,
      fuelMeter: undefined,
      errors: {},
    };

    this.handleAssign = this.handleAssign.bind(this);
    this.handleMeterSelected = this.handleMeterSelected.bind(this);
    this.goBack = this.goBack.bind(this);
    this.renderAssignForm = this.renderAssignForm.bind(this);

    this.fetchMeterData = this.fetchMeterData.bind(this);

    this.handleOrderInitialMeterQuantityChange = this.handleOrderInitialMeterQuantityChange.bind(this);
    this.handleOrderFinalMeterQuantityChange = this.handleOrderFinalMeterQuantityChange.bind(this);

    this.calculateTotalQuantityAdded = this.calculateTotalQuantityAdded.bind(this);
  }

  async componentWillMount() {
    try {
      const order = await this.fetchOrderData(this);
      const { fuelMeter, fuelTruck } = await this.fetchMeterData(order);
      const firstFuelOrder = order.fuelOrders[0];

      if (fuelMeter && fuelMeter.totalQuantity && !firstFuelOrder.initialMeterQuantity) {
        firstFuelOrder.initialMeterQuantity = fuelMeter.totalQuantity;
      }

      this.setState({
        id: order.id,
        order,
        fuelOrder: firstFuelOrder,
        fuelMeter,
        fuelTruck,
        assigning: false,
      }, () => {
        this.updateTotalQuantityAdded();
        this.handleFinalMeterQuantityError();
        console.log(this.state);
      });
    } catch (error) {
      this.notificationSystem.addNotification({
        message: `Unable to get Order ${error.message}`,
        level: 'error',
        position: 'bc',
      });
    }
  }

  fetchMeterData(order) {
    const firstFuelOrder = order.fuelOrders[0];
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.state.fboId}/fuel_meters/${firstFuelOrder.fuelMeterId}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    return Api.get(endPoint, {
      headers: myHeaders,
    }, true);
  }

  fetchOrderData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    return Api.get(endPoint, {
      headers: myHeaders,
    }, true).then(response => response.order );
  }

  calculateTotalQuantityAdded() {
    let initialMeterQuantity = 0;
    if (this.state.fuelOrder && this.state.fuelOrder.initialMeterQuantity) {
      initialMeterQuantity = this.state.fuelOrder.initialMeterQuantity;
    }

    let finalMeterQuantity = 0;
    if (this.state.fuelOrder && this.state.fuelOrder.finalMeterQuantity) {
      finalMeterQuantity = this.state.fuelOrder.finalMeterQuantity;
    }
    const total = parseFloat(finalMeterQuantity, 10) - parseFloat(initialMeterQuantity, 10);
    return total >= 0 ? total.toFixed(1) : 0;
  }

  async handleAssign() {
    try {
      await this.postOrderData();
      await this.postMeterData();
      await this.postFulfill();

      this.setState({ assigning: false });

      const { history } = this.props;
      history.push({ pathname: '/orders' });
    } catch (err) {
      this.notificationSystem.addNotification({
        message: `Unable to fulfill Order ${err.message}`,
        level: 'error',
        position: 'bc',
      });
    }
  }

  postMeterData() {
    const firstFuelOrder = this.state.fuelOrder;
    const endPoint = `v1/fbos/${this.state.fboId}/fuel_meters/${firstFuelOrder.fuelMeterId}`;
    const meterUpdate = {
      totalQuantity: this.state.fuelOrder.finalMeterQuantity
    };

    return Api.get(endPoint, {
      method: 'PUT',
      body: JSON.stringify(meterUpdate),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  postOrderData() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}`;
    // Cleanup meter data before post
    const fuelOrder = this.state.fuelOrder;
    fuelOrder.initialMeterQuantity = parseFloat(fuelOrder.initialMeterQuantity).toFixed(1);
    fuelOrder.finalMeterQuantity = parseFloat(fuelOrder.finalMeterQuantity).toFixed(1);

    const orderUpdate = {
      fuelOrders: [this.state.fuelOrder]
    };

    return Api.get(endPoint, {
      method: 'PUT',
      body: JSON.stringify(orderUpdate),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  postFulfill() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}/transition/fulfill`;

    return Api.get(endPoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  handleMeterSelected(fuelMeterId) {
    this.setState({ fuelMeterId });
  }

  handleOrderInitialMeterQuantityChange(event) {
    const fuelOrder = this.state.fuelOrder;
    const initialQuantity = parseFloat(event.target.value);
    fuelOrder.initialMeterQuantity = initialQuantity - Math.floor(initialQuantity) > 0 ?
      (Math.floor(initialQuantity * 10) / 10).toFixed(1) : initialQuantity;
    this.setState({ fuelOrder }, this.updateTotalQuantityAdded());
  }

  handleOrderFinalMeterQuantityChange(event) {
    const fuelOrder = this.state.fuelOrder;
    const finalQuantity = parseFloat(event.target.value);
    fuelOrder.finalMeterQuantity = finalQuantity - Math.floor(finalQuantity) > 0 ?
      (Math.floor(finalQuantity * 10) / 10).toFixed(1) : finalQuantity;

    this.setState({ fuelOrder }, () => {
      this.updateTotalQuantityAdded();
      this.handleFinalMeterQuantityError();
    });
  }

  handleFinalMeterQuantityError() {
    const fuelOrder = this.state.fuelOrder;
    const finalQuantity = parseFloat(fuelOrder.finalMeterQuantity).toFixed(1);
    if (finalQuantity < parseFloat(fuelOrder.initialMeterQuantity)) {
      const errors = this.state.errors;
      errors.finalMeterQuantity = "Can't be less than initial meter";
      this.setState({ errors });
    } else {
      const errors = this.state.errors;
      delete errors.finalMeterQuantity;
      this.setState({ errors });
    }
  }

  updateTotalQuantityAdded() {
    const fuelOrder = this.state.fuelOrder;
    if (fuelOrder) {
      fuelOrder.totalQuantityAdded = this.calculateTotalQuantityAdded();
      this.setState({ fuelOrder });
    }
  }

  renderAssignForm() {
    return (
      <main className="page-content">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <div className="normal-page-header">
          <h1 className="left">Set meter readings</h1>
          <div className="clear" />
        </div>
        <OrderAttributes order={this.state.order} fuelTruck={this.state.fuelTruck} fuelMeter={this.state.fuelMeter} />
        <div className="edit-form page-content-items">
          {this.state.fuelOrder &&
            <span>
              <label htmlFor="initialMeterQuantity">
              Initial Meter Reading<br />
                <input
                  id="initialMeterQuantity"
                  type="number"
                  value={this.state.fuelOrder.initialMeterQuantity || ''}
                  placeholder={this.state.fuelMeter.totalQuantity}
                  onChange={this.handleOrderInitialMeterQuantityChange}
                />
              </label>
              <label htmlFor="finalMeterQuantity">
              Final Meter Reading<br />
                <input
                  id="finalMeterQuantity"
                  className={`${this.state.errors.finalMeterQuantity ? 'error' : ''}`}
                  type="number"
                  autoFocus
                  value={this.state.fuelOrder.finalMeterQuantity || ''}
                  onChange={this.handleOrderFinalMeterQuantityChange}
                />
              </label>
              <div className="input-error-msg">{this.state.errors.finalMeterQuantity}</div>
              <label className="with-inline-label" htmlFor="totalQuantityAdded">
              Total Quantity added<br />
                <input
                  id="totalQuantityAdded"
                  type="number"
                  disabled="disabled"
                  value={this.state.fuelOrder.totalQuantityAdded || ''}
                /> <div className="side-label">Gal</div>
              </label>
            </span>
          }
          <button
            type="button"
            className="btn btn-medium btn-primary"
            onClick={this.handleAssign}
            disabled={!isEmptyObject(this.state.errors) || this.state.assigning}
          >
            Fulfill order
          </button>
          <button
            type="button"
            className="btn btn-medium btn-alternative-options"
            onClick={this.goBack}
            disabled={this.state.assigning}
          >
            Cancel
          </button>
        </div>
      </main>
    );
  }

  render() {
    return (
      <div className="app">
        { this.renderAssignForm() }
      </div>
    );
  }
}

AssignOrderPage.propTypes = {
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      fboId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

AssignOrderPage.stateTypes = {
  fboId: PropTypes.number.isRequired,
};
export default AssignOrderPage;




// WEBPACK FOOTER //
// ./src/Containers/Orders/FulfillOrderForm.js